import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux'

const PrivateRoute = () => {
  const isLogged = useSelector((state) => state.isLogged)
  const ACCtoken = useSelector((state) => state.ACCtoken)

  // If user is not authenticated, redirect to login page
  if (ACCtoken === 0 || !isLogged) {
    return <Navigate to="/login" replace />
  }

  // If authenticated, render the protected route
  return <Outlet />
}

export default PrivateRoute